import {ACCOUNT_VENDING_BASE_URL, HandleErrorResponse} from "./common";

export const fetchMPAOrgUnits = async () => {

    const endpoint = `${ACCOUNT_VENDING_BASE_URL}/mpa-org-unit`;

    try {
        const response = await fetch(endpoint, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            }
        });

        if (!response.ok) {
            await HandleErrorResponse(response);
        }

        return response.json();
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
}